import Header from './Header.vue';
import InfoCard from './InfoCard.vue';
import StageTotalCard from './StageTotalCard.vue';

export default {
    Header,
    InfoCard,
    StageTotalCard
}